import React, { useState } from 'react';
import { Box, Button, VStack, Heading, Span, HStack, Text } from '@bpba/ui-components';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Mutations } from '../rest/Mutations';
import { useMutation } from '@apollo/client';
import { Result } from './Result';
import { ResultError } from './ResultError';
import { useQuery } from "@apollo/client";
import { Queries } from "../rest/Queries";
import { AdhesionComerciosIndex } from '../rest/models/AdhesionComerciosIndex';
import { AdhesionComerciosIndexApiRQ } from '../rest/models/AdhesionComerciosIndexApiRQ';
import { postAdhesionComerciosIndex } from '../rest/mutations/postAdhesionComerciosIndex';
import { getConsultaAdhesionComercios } from "../rest/queries/getConsultaAdhesionComercios";
import { postAdhesionComerciosReenvioMail } from "../rest/mutations/postAdhesionComerciosReenvioMail";
import { useTurnstile } from 'react-turnstile';


const AdhesionComerciosComponent: React.FC = () => {


    const { register, handleSubmit, getValues, formState: { errors }, reset } = useForm<any>({ mode: 'onChange', criteriaMode: 'all', reValidateMode: 'onChange' });

    const REQUIRED_FIELD = "Campo requerido.";
    //eslint-disable-next-line
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const [errorServicio, setErrorServicio] = useState<boolean>(false);
    const [mensajeError, setMensajeError] = useState<React.ReactNode>();
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");
    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<React.ReactNode>();
    const [cuit, setCuit] = useState(0);
    const [cuitValidado, setCuitValidado] = useState<boolean>(false);
    const [postAdhesionComerciosIndexApi, { loading: loadingAdhesionComerciosIndex }] = useMutation<Mutations>(postAdhesionComerciosIndex);
    const [postReenvioMailApi, { loading: loadingReenvioMail }] = useMutation<Mutations>(postAdhesionComerciosReenvioMail);
    const [getTrnToken, setGetTrnToken] = useState<boolean>(false);
    const toknTurnstile = useTurnstile();

    const { data: { consultaAdhesionComercios } = {}, loading: loadingConsulta } = useQuery<Queries>(getConsultaAdhesionComercios, {
        variables: { cuit: cuit }, skip: !cuit, onCompleted(data) {
           
            if (consultaAdhesionComercios?.estado === 1) {
                setServicioOk(true);
                setErrorServicio(false);
                setMensajeRtaServicio(<Text>Ya existe una solicitud con ese cuit <br /><br />
                    Necesito que me <b style={{ cursor: "pointer" ,textDecoration: "underline"}} onClick={() => reenvioMail()} > reenvien el mail </b> </Text>);

            } else if (consultaAdhesionComercios?.estado === 2) {
                setServicioOk(true);
                setErrorServicio(false);
                setMensajeRtaServicio(<Text>El cuit ingresado ya posee una solicitud en proceso.</Text>);
            }
            else if (!consultaAdhesionComercios) {
                setErrorServicio(true);
                setMensajeError("Ha ocurrido un problema, inténtelo mas tarde.");
            } else {
                setErrorServicio(false);
                setMensajeError("");
                setCuitValidado(true)
            }
        }, onError(e: any) {
            
            if (e.networkError.statusCode === 409) {
                setErrorServicio(true);
                setMensajeError(JSON.parse(JSON.stringify(e.networkError)).result.Message);

            }
            if (e.networkError.statusCode === 500) {
                setErrorServicio(true);
                setMensajeError("500 Internal Server Error");

            }
        }
    });

    async function reenvioMail() {

        setGetTrnToken(true);

        let datos: AdhesionComerciosIndexApiRQ = {
            "googleToken": "",
            "cuit": consultaAdhesionComercios?.cuit ? consultaAdhesionComercios?.cuit : 0,
            "email": consultaAdhesionComercios?.email ? consultaAdhesionComercios?.email : " ",
        };

        toknTurnstile.execute(document.getElementById('turnStileTkncontainer'),{
            sitekey: process.env.REACT_APP_TKN_SITEKEY!,
            callback: async (token:any)=>{
                datos.googleToken=token



        await postReenvioMailApi({ variables: { input: datos } }).then((response: any) => {
            setGetTrnToken(false);

            if (response.data.AdhesionComerciosIndexApiRQ.resultado === "OK") {
                setServicioOk(true);
                setMensajeRtaServicio(<>Te enviamos un mail a tu casilla de correo con la presolicitud. Por favor, ingresá. <br />¿No recibiste el mail? Revisá tu buzón de SPAM (correo no deseado) de tu casilla, si aún no lo encontrás, ingresá tus datos nuevamente haciendo clic <b onClick={() => handleReset()} style={{ cursor: "pointer" }}>aquí</b>.</>);

            } else {
                setServicioOk(false);
                setMensajeErrorPostProspecto("Tuvimos un problema. Volvé a intentar más tarde y si el error continúa comunicate al 0810-666-0098");
            }
        }).catch(() => {
            setGetTrnToken(false);
            setServicioOk(false);
            setMensajeErrorPostProspecto("Tuvimos un problema. Volvé a intentar más tarde y si el error continúa comunicate al 0810-666-0098");

        });

 } });

    }

    const onSubmit: SubmitHandler<AdhesionComerciosIndex> = async (data: AdhesionComerciosIndex) => cuitValidado ? SubmitForm(data) : setCuit(data.cuit)

    const SubmitForm: SubmitHandler<AdhesionComerciosIndex> = async (data: AdhesionComerciosIndex) => {


        if (getValues("email") === getValues("confirm_email")) {
            let datos: AdhesionComerciosIndexApiRQ = {
                "googleToken": "",
                "cuit": Number(data.cuit),
                "email": data.email

            };

            toknTurnstile.execute(document.getElementById('turnStileTkncontainer'),{
                sitekey: process.env.REACT_APP_TKN_SITEKEY!,
                callback: async (token:any)=>{
                    datos.googleToken=token
    

                    
            await postAdhesionComerciosIndexApi({ variables: { input: datos } }).then((response: any) => {

                if (response !== null || response !== undefined) {
                    if (response.data.AdhesionComerciosIndexApiRQ.resultado.toString().toLocaleLowerCase() === "OK".toLocaleLowerCase()) {
                        setServicioOk(true);
                        setMensajeRtaServicio("Solicitud creada con éxito! Te enviamos un mail a tu casilla de correo. Por favor, ingresá  y hace clic en el link que recibiste.¿No recibiste el mail? Revisá tu buzón de SPAM (correo no deseado) de tu casilla");

                    } else if (response.data.AdhesionComerciosIndexApiRQ.error.includes("existe")) {
                        setServicioOk(true);
                        //setMensajeRtaServicio("Ya existe el registro para el formulario seleccionado");
                        setMensajeRtaServicio(<>Ya existe una solicitud con ese cuit
                            Necesito que me reenvien el mail <a href="https://www.bancoprovincia.com.ar/cuentadni/contenidos/cdniComercios" style={{ textDecoration: "none", color: "red", fontWeight: "bold" }}>acá</a> </>);

                    } else {
                        setServicioOk(true);
                        setMensajeRtaServicio(response.data.AdhesionComerciosIndexApiRQ.error);

                    }
                } else {
                    setServicioOk(false);
                    setMensajeErrorPostProspecto("Tuvimos un problema. Volvé a intentar más tarde y si el error continúa comunicate al 0810-666-0098");

                }


            }).catch(() => {
                setServicioOk(true);
                setMensajeRtaServicio("Tuvimos un problema. Volvé a intentar más tarde y si el error continúa comunicate al 0810-666-0098");

            }); 
        } });


        } else {
            return "Los emails no coinciden";
        }

 
    }





    if (getTrnToken || loadingAdhesionComerciosIndex || loadingConsulta || loadingReenvioMail) return <SpinnerCajas />;
    const handleReset = () => {
        reset({});
        window.location.reload();
    };
    if (servicioOk) return (

        <Result handleReset={handleReset}>
            <VStack>
                <Heading level={2} fontWeight={400} children={mensajeRtaServicio} color="primary.0" tabIndex={0} />
            </VStack>
        </Result>

    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>
    );


    return (

        <Box>
            <VStack>
                <form onSubmit={handleSubmit(onSubmit)}>

                    <Heading level={3} mb={'8px'} fontWeight={400} tabIndex={0}>
                        Datos Generales
                    </Heading>
                    {errorServicio ?
                        <VStack mt={"20px"}>
                            <Span color="red" fontSize={"12px"} tabIndex={0}>
                                {mensajeError}
                            </Span>
                            <Button
                                onClick={() => handleReset()}
                                variant="secondary"
                                py={"10px !important"}
                            >
                                Volver
                            </Button>
                        </VStack> :
                        <>
                            {cuitValidado ?
                                <>
                                    <VStack>
                                        <Text fontSize={"12px"} color={'primary.0'} textAlign={"justify"}>Recordá que este formulario es para contratar terminales de cobro en tu comercio. Podrás cobrar a usuarios de Cuenta DNI, Tarjetas y a todas las billeteras del mercado, si tenés dudas o consultas acerca de otro producto o servicio del banco, te invitamos a que visites nuestra <a href={"https://www.bancoprovincia.com.ar/"} target={"_blank"} style={{ color: "#279d2e", fontWeight: "bold"}}>web</a> o comunicate al centro de contacto telefónico 0810 222 2776.</Text>
                                        <input type={"text"} tabIndex={0}
                                            {...register("cuit", {
                                                required: REQUIRED_FIELD, minLength: { value: 11, message: "cantidad minima de caracteres: 11" },
                                                maxLength: 11
                                            })}
                                            name='cuit' id='cuit' placeholder='CUIT ej: 30123456789' maxLength={11} minLength={11} disabled />

                                    </VStack>

                                    <VStack mt={"20px"}>
                                        <input type={'text'} {...register("email", { required: REQUIRED_FIELD, pattern: { value: mailValidator, message: "Formato de email inválido ejemplo: juana@mail.com" } })} name="email" placeholder='E-mail' maxLength={100} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.email ? "* " + errors.email.message : ""}</Span>
                                    </VStack>


                                    <VStack mt={"20px"}>
                                        <input type={'text'} placeholder='Confirmacion E-mail' maxLength={100} {...register("confirm_email", {
                                            required: REQUIRED_FIELD, validate: (value) => getValues("email") === value || "Los emails no coinciden"
                                        })} name="confirm_email" autoComplete="off" />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.confirm_email ? "* " + errors.confirm_email.message : ""}</Span>
                                    </VStack>

                                    <HStack mt={"20px"} alignItems={"baseline"}>
                                        <input type='checkbox' tabIndex={0} style={{ transform: "scale(1.3)", marginBottom: "2px" }} {...register("check", { required: REQUIRED_FIELD })} />
                                        <Span ml={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                            Acepto que mis datos de contacto sean enviados a la empresa por la cual suscribo la presente pre-solicitud.
                                        </Span>
                                    </HStack>
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.check?.message}</Span>

                                    <Button type="submit" variant="secondary" py={"10px !important"}>Validar</Button>

                                </>
                                :
                                <VStack>
                                    <input type={"text"} tabIndex={0}
                                        {...register("cuit", {
                                            required: REQUIRED_FIELD, minLength: { value: 11, message: "cantidad minima de caracteres: 11" },
                                            maxLength: 11
                                        })}
                                        name='cuit' id='cuit' placeholder='CUIT ej: 30123456789' maxLength={11} minLength={11} />
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>
                                        {errors.cuit ? "* " + errors.cuit.message : ""}
                                    </Span>
                                    <Button type="submit" variant="secondary" py={"10px !important"}>Validar</Button>
                                </VStack>



                            }
                        </>}
                        
         
                </form>
            </VStack>
            
        </Box>
        
    )

};



export default AdhesionComerciosComponent;
